import {
  TokenUSDT,
  TokenUSDC,
  NetworkEthereum,
  NetworkPolygon,
  NetworkArbitrumSepolia ,
  NetworkBase,
  NetworkTron,
  NetworkSolana,
} from "@web3icons/react";
import { CryptoNetworkCode, CryptoToken } from "./types";

type IconComponent = React.ComponentType<{
  size?: number | string;
  variant?: "mono" | "branded" | "background";
  className?: string;
}>;

const TOKEN_COMPONENTS: Record<CryptoToken, IconComponent> = {
  USDT: TokenUSDT,
  USDC: TokenUSDC,
};

const NETWORK_COMPONENTS: Record<CryptoNetworkCode, IconComponent> = {
  ethereum: NetworkEthereum,
  polygon: NetworkPolygon,
  arbitrum: NetworkArbitrumSepolia ,
  base: NetworkBase,
  tron: NetworkTron,
  solana: NetworkSolana,
};

export const TokenIcon = ({
  token,
  size = 28,
  className = "",
}: {
  token: CryptoToken;
  size?: number;
  className?: string;
}) => {
  const Icon = TOKEN_COMPONENTS[token];
  if (!Icon) return null;
  return <Icon size={size} variant="branded" className={className} />;
};

export const NetworkIcon = ({
  network,
  size = 20,
  className = "",
}: {
  network: CryptoNetworkCode;
  size?: number;
  className?: string;
}) => {
  const Icon = NETWORK_COMPONENTS[network];
  if (!Icon) return null;
  return <Icon size={size} variant="branded" className={className} />;
};